import React from 'react';
import cn from 'classnames';

import type { ClearButtonProps } from '../types';

import { ClearIcon } from './icons';

const ClearButton = ({ clearIcon, className, visible = false, onMouseDown }: ClearButtonProps) => {
  // Не используйте onClick, т.к. с ним нельзя предотвратить input blur во время щелчка
  return (
    <button
      className={cn(
        'e-input__clear-button',
        { 'e-input__clear-button--hidden': !visible },
        className
      )}
      onMouseDown={onMouseDown}
    >
      {clearIcon ?? (
        <ClearIcon width="18px" height="18px" className="e-input__icon e-input__icon--clear" />
      )}
    </button>
  );
};

export default ClearButton;
